import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useApiCall from '../../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import ConsultsService from '../../../../services/ConsultsService';
import MapDataView from '../../../MapDataView';
import MyModal from '../../../Modal';
import { FullDataType, GetMapDataViewDataApiResponse } from './types';

interface IMapDataViewModal {
  mapDataViewModalShow: boolean;
  setMapDataViewModalShow: Dispatch<SetStateAction<boolean>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  consultCode: string;
}

export default function MapDataViewModal({
  mapDataViewModalShow,
  setMapDataViewModalShow,
  setIsLoading,
  consultCode,
}: IMapDataViewModal) {
  const { apiCall } = useApiCall();
  const { userCode, userProfile, isCustomer, usersCompanyCode } = useGetGeneralAppData();

  const [mapData, setMapData] = useState<FullDataType[]>([]);

  const getMapData = useCallback(async () => {
    await apiCall({
      apiToCall: ConsultsService.getMapDataViewData,
      queryParams: {
        codUsu: userCode,
        perfilUsu: userProfile,
        codEmpresa: isCustomer ? usersCompanyCode : 0,
        tipoSelecao: 1,
        codConsulta: consultCode,
        codArq: 0,
        tipoArq: 0,
      },
      onStartLoad: () => setIsLoading(true),
      onEndLoad: () => setIsLoading(false),
      actionAfterResponse: (response: GetMapDataViewDataApiResponse) => {
        if (!response.codigo) {
          setMapDataViewModalShow(false);
          toast.error(`Erro ao buscar dados do mapa de tendência (${response.msg})`);
          return;
        }

        const { dadosMapa } = response;
        if (!dadosMapa.length) {
          setMapDataViewModalShow(false);
          toast.info('Nenhum dado encontrado para o mapa de tendência');
          return;
        }

        const mappedData = dadosMapa.map((data) => ({
          cpf: data.cpf,
          consultCode: String(data.codConsulta),
          companyCode: String(data.codEmpresa),
          name: String(data.nome),
          employeeStreetName: data.func_Logradouro,
          employeeNumber: String(data.func_numero),
          employeeCep: data.func_Cep,
          employeeLat: String(data.func_Lat),
          employeeLng: String(data.func_Long),
          entryTime: data.hora_Entra,
          exitTime: data.hora_Saida,
          oldValue: String(data.vt_Informado),
          newValue: String(data.vt_Roteirizado),
          workplaceCode: String(data.codLocalA),
          workplaceCep: data.local_Cep,
          workplaceStreetName: data.local_Logradouro,
          workplaceNumber: String(data.local_Numero),
          workplaceName: data.localTrab,
          workplaceLat: String(data.local_Lat),
          workplaceLng: String(data.local_Long),
          highlighted: data.highlighted,
          criminalRisc: data.riscoCriminalidade,
        }));

        setMapData(mappedData);
      },
      catchAction: () => setMapDataViewModalShow(false),
      catchMessage: 'Erro ao buscar dados do mapa de tendência',
    });
  }, [apiCall, consultCode, isCustomer, setIsLoading, setMapDataViewModalShow, userCode, userProfile, usersCompanyCode]);

  useEffect(() => {
    if (!mapDataViewModalShow) return;
    getMapData();
  }, [getMapData, mapDataViewModalShow]);

  return (
    <MyModal
      show={mapDataViewModalShow}
      title={`Mapa de Tendência - Consulta ${consultCode}`}
      closeButtonLabel="Fechar"
      onClose={() => setMapDataViewModalShow(false)}
      type="info"
      fullscreen
      size='xl'
      modalBody={<MapDataView fullData={mapData} />}
    />
  );
}
